import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import BusinessAudit from './pages/BusinessAudit';
import ContentPage from './pages/ContentPage';
import AdminDashboard from './pages/AdminDashboard';
import AiAssistant from './components/AiAssistant';

// vNext features
import QuizPage from './pages/QuizPage';
import CrisisProtocol from './pages/CrisisProtocol';
import Login from './pages/Login';
import Certificate from './pages/Certificate';

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isOrgMode } = useAuth();
  const location = useLocation();

  if (isOrgMode && !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

// Ohjaus vanhoista polusta uuteen rakenteeseen
const LegacyRedirect: React.FC<{ target: string }> = ({ target }) => <Navigate to={`/content/${target}`} replace />;

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/business-audit" element={<BusinessAudit />} />
              <Route path="/admin" element={<AdminDashboard />} />
              
              {/* Legacy redirects */}
              <Route path="/cyber-basics" element={<LegacyRedirect target="kyber-perusteet" />} />
              <Route path="/ai-safety" element={<LegacyRedirect target="ai-safety" />} />
              <Route path="/mobile-security" element={<LegacyRedirect target="mobiiliturva" />} />
              <Route path="/routines" element={<LegacyRedirect target="routines" />} />
              <Route path="/tietosuoja-perusteet" element={<LegacyRedirect target="tietosuoja-perusteet" />} />
              <Route path="/salaus-opas" element={<LegacyRedirect target="salaus-opas" />} />
              <Route path="/tunnistautuminen-ja-mfa" element={<LegacyRedirect target="tunnistautuminen-ja-mfa" />} />
              <Route path="/huijaukset-ja-deepfaket" element={<LegacyRedirect target="huijaukset-ja-deepfaket" />} />
              <Route path="/trendit-2026" element={<LegacyRedirect target="trendit-2026" />} />
              <Route path="/incident-response" element={<LegacyRedirect target="incident-response" />} />

              <Route path="/quiz/:id" element={
                <RequireAuth><QuizPage /></RequireAuth>
              } />
              
              <Route path="/certificate" element={<Certificate />} />
              <Route path="/crisis-protocol" element={<CrisisProtocol />} />
              
              {/* Master Content Template */}
              <Route path="/content/:slug" element={<ContentPage />} />
              
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <AiAssistant />
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;